
import React from 'react';
import { Badge } from 'antd';

interface NotificationBadgeProps {
  unreadLabel: string;
  children: React.ReactNode;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({ unreadLabel, children }) => {
  const count = Number(unreadLabel);
  const show = unreadLabel === '99+' || count > 0;
  return (
    <Badge count={show ? unreadLabel : 0} overflowCount={99} size="small">
      {children}
    </Badge>
  );
};
